module.exports = __webpack_public_path__ + "img/inwoners.431917c1.svg";